import { render, staticRenderFns } from "./allocationRecord.vue?vue&type=template&id=15604ac3&scoped=true&"
import script from "./allocationRecord.vue?vue&type=script&lang=js&"
export * from "./allocationRecord.vue?vue&type=script&lang=js&"
import style0 from "./allocationRecord.vue?vue&type=style&index=0&id=15604ac3&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15604ac3",
  null
  
)

export default component.exports